module.exports = __webpack_public_path__ + "img/HOME-7.9a853a34.png";